//---------------------------------------------
// Auth Module 
//---------------------------------------------
// Módulo para gerenciar as ações de autenticação

import axios from '../../services/api';
import Cookies from 'js-cookie';
// var qs = require('qs');
var JWT = () => {
    return (Cookies.get("accessToken") ? Cookies.get("accessToken") : "JWT VAZIO")
}

// STATES
const state = () => ({
    isLogged: null,
    signUp: null,
    userInfo: null,
    expireCookieDate: null,
    highContrast: null,
    isAlreadyShowedExpNotyf: false,
    errorRegisterNewUser: false,
    isValidEmail: false,
    isResendVerificationMail: null,
    isResetPassword: false,
    userConfirmed: null
})

// MUTATIONS
const mutations = {
    setHigh(state, payload) {
        state.highContrast = payload
    },
    //-- MUTATION PARA ESTADO DO LOGIN
    setIsLogged(state, payload) {
        state.isLogged = payload
    },

    //-- MUTATION PARA CRIAR USUÁRIO (SIGN UP)
    setSignUp(state, payload) {
        state.signUp = payload
    },

    //-- MUTATION PARA AS INFOS DO USER
    setUserInfo(state, payload) {
        state.userInfo = payload
    },

    //-- MUTATION PARA A HORA DE EXPIRACAO DO TOKEN DA SESSAO
    setExpireCookieDate(state, payload) {
        state.expireCookieDate = payload
    },

    //-- MUTATION PARA O BOOLEAN DA EXIBICAO DA NOTIFICACAO DE EXPIRACAO
    setIsAlreadyShowedExpNotyf(state, payload) {
        state.isAlreadyShowedExpNotyf = payload
    },

    //-- MUTATION PARA O BOOLEAN DE ERRO AO REGISTRAR
    setErrorRegisterNewUser(state, payload) {
        state.errorRegisterNewUser = payload
    },

    //-- MUTATION PARA O BOOLEAN DE EMAIL VALIDO
    setIsValidEmail(state, payload) {
        state.isValidEmail = payload
    },

    //-- MUTATION PARA O BOOLEAN DE REDEFINICAO DE SENHA
    setIsResetPassword(state, payload) {
        state.isResetPassword = payload
    },

    //-- MUTATION PARA O BOOLEAN DE REENVIO DE EMAIL
    setResendVerificationMail(state, payload) {
        state.resendVerificationMail = payload
    },

    //-- MUTATION PARA A CONFIRMAÇÃO DE USUÁRIO
    setUserConfirmed(state, payload) {
        state.userConfirmed = payload;
    }

}

// ACTIONS
const actions = {
    async setHighContrast({ commit }, payload) {
        try {
            commit('setHigh', payload);
        } catch (error) {
            console.log(error);
        }
    },

    //-- ACTION REQUISICAO DO LOGIN
    async setLogin({ commit }, payload) {
        await axios
            .post(`auth/signin`, {
                email: payload.email,
                senha: payload.senha
            })
            .then((response) => {
                let today = new Date();
                // today.setMinutes(today.getMinutes() + 2); //COMENTADO PARA TESTES
                today.setHours(today.getHours() + 1);
                commit('setIsLogged', true)
                commit('setExpireCookieDate', today)
                Cookies.set("accessToken", response.data.accessToken, {
                    expires: 1 / 24
                })
            })
            .catch(() => {
                commit('setIsLogged', false)
                commit('setExpireCookieDate', null)
            })
    },

    //-- ACTION REQUISICAO DO TOKEN
    async setVerifyToken({ commit }) {
        await axios
            .get(`auth/verifyToken`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
                commit('setIsLogged', true)
            })
            .catch(() => {
                commit('setIsLogged', false)
            })
    },

    //-- ACTION REQUISICAO DO REFRESH TOKEN
    async setRefreshToken({ commit }) {
        await axios
            .get(`auth/refreshToken`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then((response) => {
                commit('setIsLogged', true)
                let today = new Date();
                // today.setMinutes(today.getMinutes() + 2); // USADO EM TESTES
                today.setHours(today.getHours() + 1);
                commit('setIsLogged', true)
                commit('setExpireCookieDate', today)
                Cookies.set("accessToken", response.data.accessToken, {
                    expires: 1 / 24
                })
            })
            .catch(() => {
                commit('setIsLogged', false)
            })
    },

    //-- ACTION REQUISICAO DAS INFOS DO USER
    async setUserInfo({ commit }) {
        await axios
            .get(`auth`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then((response) => {
                commit('setUserInfo', response.data)
            })
            .catch((error) => {
                console.log(error)
            })
    },

    //-- ACTION REQUISICAO DE CRIAR USUÁRIO
    async setSignUp({ commit }, payload) {
        await axios
            .post(`auth/signup`, {
                nome: payload.nome,
                email: payload.email,
                genero: payload.genero,
                dataNascimento: payload.dataNascimento,
                formacao: payload.formacao,
                telefone: payload.telefone,
                estado: payload.estado,
                cidade: payload.cidade,
                distrito: payload.distrito,
                logradouro: payload.logradouro,
                numero: payload.numero,
                bairro: payload.bairro,
                cep: payload.cep,
                senha: payload.senha
            })
            .then(() => {
                // console.log('Cadastrado com sucesso!')
                commit('setErrorRegisterNewUser', false)
            })
            .catch((error) => {
                console.log(error.message)
                commit('setErrorRegisterNewUser', true)
            })
    },

    //-- ACTION REQUISICAO DE EMAIL VÁLIDO
    async setIsValidEmail({ commit }, payload) {
        await axios
            .get(`usuarios/isValidEmail?email=${payload}`,{
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then((response) => {
                commit('setIsValidEmail', response.data)
            })
            .catch((error) => {
                console.log(error.message)
            })
    },

    //-- ACTION REQUISICAO DE RESEND EMAIL DE CONFIRMACAO
    async setResendVerificationMail({ commit }, payload) {
        await axios
            .get(`auth/resendVerificationMail?email=${payload}`)
            .then(() => {
                commit('setResendVerificationMail', true)
            })
            .catch((error) => {
                console.log(error)
                commit('setResendVerificationMail', false)
            })
    },

    //-- ACTION REQUISICAO DE SEND EMAIL DE REDEFINICAO
    async setSendResetPasswordMail(_, payload) {
        await axios
            .get(`auth/sendResetPasswordMail?email=${payload}`)
            .then(() => {
            })
            .catch((error) => {
                console.log(error)
            })
    },

    //-- ACTION REQUISICAO DE REDEFINIR SENHA
    async setResetPassword({commit}, payload) {
        await axios
            .put(`auth/resetPassword?email=${payload.email}&token=${payload.token}`, {
                senhaNova: payload.senhaNova,
            })
            .then(() => {
                commit('setIsResetPassword', true)
            })
            .catch((error) => {
                commit('setIsResetPassword', false)
                console.log(error.message)
            })
    },



    //-- ACTION REQUISICAO DE ALTERAR USUÁRIO
    async setUpdateUser(_, payload) {
        await axios
            .put(`usuarios`, {
                nome: payload.nome,
                email: payload.email,
                genero: payload.genero,
                dataNascimento: payload.dataNascimento,
                formacao: payload.formacao,
                telefone: payload.telefone,
                estado: payload.estado,
                cidade: payload.cidade,
                distrito: payload.distrito,
                logradouro: payload.logradouro,
                numero: payload.numero,
                bairro: payload.bairro,
                cep: payload.cep
            }, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
            })
            .catch((error) => {
                console.log(error.message)
            })
    },

    //-- ACTION REQUISIÇÃO CONFIRMAR CONTA
    async setConfirmAccount({ commit }, payload) {
        await axios
            .post(`usuarios/register-member/${payload.token}`, {
                nome: payload.nome,
                email: payload.email,
                genero: payload.genero,
                dataNascimento: payload.dataNascimento,
                formacao: payload.formacao,
                telefone: payload.telefone,
                estado: payload.estado,
                cidade: payload.cidade,
                distrito: payload.distrito,
                logradouro: payload.logradouro,
                numero: payload.numero,
                bairro: payload.bairro,
                cep: payload.cep,
                senha: payload.senha
            })
            .then(() => {
                commit('setUserConfirmed', true);
            })
            .catch((err) => {
                console.log("Erro na confirmação de nova conta convidada: ", err);
                commit('setUserConfirmed', false);
            });
    }

}

// GETTERS
const getters = {
    getIsLogged(state) {
        return state.isLogged
    },

    getHighContrast(state) {
        return state.highContrast;
    },

    getUserInfo(state) {
        return state.userInfo
    },

    getSignUp(state) {
        return state.signUp
    },

    getExpireCookieDate(state) {
        return state.expireCookieDate
    },

    getIsAlreadyShowedExpNotyf(state) {
        return state.isAlreadyShowedExpNotyf
    },

    getErrorRegisterNewUser(state) {
        return state.errorRegisterNewUser
    },

    getIsValidEmail(state) {
        try {
            return state.isValidEmail.data
        } catch (e) {
            return false
        }
    },

    getResendVerificationMail(state) {
        return state.resendVerificationMail
    },

    getIsResetPassword(state) {
        return state.isResetPassword
    },

    getIsUserConfirmed(state) {
        return state.userConfirmed;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
